export default __webpack_public_path__ + "static/media/exmo.6422fd89.svg";